export default "__VITE_ASSET__B1zhFzg9__"